module.exports = __webpack_public_path__ + "static/media/logoorange.84ebbb02.png";